import clsx from 'clsx';
// mantine
import { Badge, UnstyledButton } from '@mantine/core';
// assets
import styles from '@/pages/Workflow/components/Filters/components/WorkflowItem/WorkflowItem.module.css';

interface WorkflowItemProps {
    isSelected?: boolean;
    name: string;
    count: number;
    onClick?: () => void;
}

const WorkflowItem = ({
    isSelected,
    name,
    count,
    onClick
}: WorkflowItemProps) => {
    return (
        <UnstyledButton
            className={clsx(styles.item, {
                [styles.isSelected]: isSelected
            })}
            onClick={onClick}
        >
            <div className="break-all font-semibold">{name}</div>
            <Badge className="mt-1 shrink-0" color="blue" size="xs">
                {count}
            </Badge>
        </UnstyledButton>
    );
};

export default WorkflowItem;
